import React, { useEffect, useState } from 'react';
import { Row, Col, Divider, DatePicker, Spin } from 'antd';
import { useQuery } from '@apollo/client';
import { CloseOutlined } from '@ant-design/icons';
import { Button, Form, Select, AccountCard } from '..';
import AdvanceFilterWrapper from './style';
import { AuthService } from '../../services';
import {
  GET_LIST_CAMPAIGNS,
  GET_LIST_AD_SET,
  GET_LIST_AD,
  GET_LIST_MEMBERS,
  GET_LIST_SOCMED_ACCOUNTS,
  GET_LIST_AD_INTEGRATION_ADVANCE_FILTER,
} from '../../graphql/queries';
import variables, {
  variablesTeamMember,
  variablesSocmed,
  variablesIntegrator,
  initialValues,
  onReset,
} from './handler';
import { getLastSubId } from '../../utils/commonUtils';
import { socmedTypeList } from '../../configs/socmedType';

const Index = (props) => {
  const { onHideAdvFilter, onSearchAdvFilter, refinerNewReport, searchQuery } =
    props;
  const userData = AuthService.getUserData();
  const teamId = userData.team.id;
  const [form] = Form.useForm();
  const [campaignKeyword, setCampaignKeyword] = useState('');
  const [campValue, setCampValue] = useState(null);
  const [adSetKeyword, setAdSetKeyword] = useState('');
  const [adSetValue, setAdSetValue] = useState(null);
  const [adKeyword, setAdKeyword] = useState('');
  const [memberKeyword, setMemberKeyword] = useState('');
  const [socmedKeyword, setSocmedKeyword] = useState('');
  const [socmedType, setSocmedType] = useState(null);
  const [integratorKeyword, setIntegratorKeyword] = useState('');
  const [integratorValue, setIntegratorValue] = useState(null);

  const { data, loading: isLoadingCampaign } = useQuery(GET_LIST_CAMPAIGNS, {
    variables: variables({ teamId, keyword: campaignKeyword }),
  });
  const { data: dataAdSet, loading: isLoadingAdSet } = useQuery(
    GET_LIST_AD_SET,
    {
      variables: variables({
        teamId,
        keyword: adSetKeyword,
        campValue,
      }),
    }
  );
  const { data: dataAd, loading: isLoadingAd } = useQuery(GET_LIST_AD, {
    variables: variables({ teamId, keyword: adKeyword, adSetValue }),
  });
  const campaignList = data?.GetCampaignList?.data || [];
  const adSetList = dataAdSet?.GetAdSetList?.data || [];
  const adList = dataAd?.GetAdList?.data || [];

  const { data: dataMember, loading: isLoadingMember } = useQuery(
    GET_LIST_MEMBERS,
    {
      variables: variablesTeamMember({ teamId, keyword: memberKeyword }),
    }
  );
  const [memberListState, setMemberListState] = useState([]);

  useEffect(() => {
    const memberList = dataMember?.GetTeamMemberList?.data || [];
    setMemberListState(memberList);
  }, [dataMember?.GetTeamMemberList]);

  const { data: dataSocmed, loading: isLoadingSocmed } = useQuery(
    GET_LIST_SOCMED_ACCOUNTS,
    {
      variables: variablesSocmed({
        teamId,
        socmedType,
        keyword: socmedKeyword,
      }),
    }
  );

  const socmedList = dataSocmed?.GetSocmedAccountList?.data || [];

  const { data: dataIntegrator, loading: isLoadingIntegrator } = useQuery(
    GET_LIST_AD_INTEGRATION_ADVANCE_FILTER,
    {
      variables: variablesIntegrator({ keyword: integratorKeyword, teamId }),
    }
  );
  const adIntegratorList = dataIntegrator?.GetAdIntegrationList?.data || [];

  const onSearch = (value, setKeyword) => {
    setTimeout(() => {
      setKeyword(value);
    }, 700);
  };

  useEffect(() => {
    setCampValue(searchQuery?.campaign_id);
    setAdSetValue(searchQuery?.ad_set_id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <AdvanceFilterWrapper refinerNewReport={refinerNewReport}>
      <Form
        layout="vertical"
        requiredMark={false}
        onFinish={onSearchAdvFilter}
        form={form}
        initialValues={initialValues(searchQuery)}
      >
        <div className="containers_advanceFilter_body">
          <div className="title black1">
            <div className="font-subtitle1_medium ">Advance Filter</div>
            <CloseOutlined
              style={{ fontSize: 16 }}
              onClick={() => {
                onHideAdvFilter();
              }}
            />
          </div>
          <div className="font-paragraph_medium black1 subtitle">
            By Promoter
          </div>
          <Row gutter={24}>
            <Col span={12}>
              <Form.Item label="Campaign" name="campaign_id">
                <Select
                  placeholder="Search by Name or ID"
                  showSearch
                  allowClear
                  onSearch={(e) => {
                    onSearch(e, setCampaignKeyword);
                  }}
                  onSelect={(value) => {
                    setCampValue(value);
                    setAdSetValue(null);
                    form.setFieldsValue({ ad_set_id: null, ad_id: null });
                  }}
                  notFoundContent={
                    isLoadingCampaign ? <Spin size="small" /> : 'Not found'
                  }
                  filterOption={false}
                  onClear={() => {
                    form.setFieldsValue({
                      ad_set_id: null,
                      ad_id: null,
                      integrator_id: null,
                    });
                    setCampValue(null);
                  }}
                  loading={isLoadingCampaign}
                >
                  {campaignList.map((item) => {
                    return (
                      <Select.Option
                        value={item?.id}
                        label={item?.name}
                        key={item?.id}
                      >
                        {`${item?.name} (${
                          item?.id && getLastSubId(item?.id)
                        })`}
                      </Select.Option>
                    );
                  })}
                </Select>
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item label="Ad Set" name="ad_set_id">
                <Select
                  value={adSetValue}
                  placeholder="Search by Name or ID"
                  showSearch
                  allowClear
                  onSearch={(e) => {
                    onSearch(e, setAdSetKeyword);
                  }}
                  onSelect={(value) => {
                    setAdSetValue(value);
                    form.setFieldsValue({ ad_id: null });
                  }}
                  notFoundContent={
                    isLoadingAdSet ? <Spin size="small" /> : 'Not found'
                  }
                  onClear={() => {
                    form.setFieldsValue({ ad_id: null, integrator_id: null });
                    setAdSetValue(null);
                  }}
                  filterOption={false}
                  loading={isLoadingAdSet}
                >
                  {adSetList.map((item) => {
                    return (
                      <Select.Option
                        value={item?.id}
                        label={item?.name}
                        key={item?.id}
                      >
                        {`${item?.name} (${
                          item?.id && getLastSubId(item?.id)
                        })`}
                      </Select.Option>
                    );
                  })}
                </Select>
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item label="Ad" name="ad_id">
                <Select
                  placeholder="Search by Name or ID"
                  showSearch
                  allowClear
                  onSearch={(e) => {
                    onSearch(e, setAdKeyword);
                  }}
                  notFoundContent={
                    isLoadingAd ? <Spin size="small" /> : 'Not found'
                  }
                  filterOption={false}
                  loading={isLoadingAd}
                  onSelect={() => {
                    form.setFieldsValue({ integrator_id: null });
                  }}
                >
                  {adList.map((item) => {
                    return (
                      <Select.Option
                        value={item?.id}
                        label={item?.name}
                        key={item?.id}
                      >
                        {`${item?.name} (${
                          item?.id && getLastSubId(item?.id)
                        })`}
                      </Select.Option>
                    );
                  })}
                </Select>
              </Form.Item>
            </Col>
            {/* <Row gutter={24}>
            <Col span={12}>
              <Form.Item label="Brand PIC" name="brand_pic">
                <Input placeholder="Search by User ID or Name" />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item label="Brand Creator" name="brand_creator">
                <Input placeholder="Search by User ID or Name" />
              </Form.Item>
            </Col>
          </Row> */}
            {/* <Row gutter={24}>
            <Col span={12}>
              <Form.Item label="Agency PIC" name="agency_pic">
                <Input placeholder="Search by User ID or Name" />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item label="Agency Creator" name="agency_creator">
                <Input placeholder="Search by User ID or Name" />
              </Form.Item>
            </Col>
          </Row> */}
            {/* <Col span={12}>
              <Row gutter={24}>
                <Col span={12}>
                  <Form.Item label="Ad Budget" name="ad_budget_min">
                    <Input placeholder="Input min amount" />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item label=" " name="ad_budget_max">
                    <Input placeholder="Input max amount" />
                  </Form.Item>
                </Col>
              </Row>
            </Col> */}
          </Row>

          <Divider />
          <div className="font-paragraph_medium black1 subtitle">
            By Integrator
          </div>
          <Row gutter={24}>
            <Col span={12}>
              <Form.Item label="Integrator" name="integrator_id">
                <Select
                  placeholder="Search by Ad Name or ID"
                  showSearch
                  allowClear
                  onSearch={(e) => {
                    onSearch(e, setIntegratorKeyword);
                  }}
                  notFoundContent={
                    isLoadingIntegrator ? <Spin size="small" /> : 'Not found'
                  }
                  filterOption={false}
                  loading={isLoadingIntegrator}
                  onSelect={(value, record) => {
                    const integrator = record?.label;
                    const approvedBy = integrator?.approved_by;
                    const isExist = memberListState?.find((item) => {
                      return item?.user_id === approvedBy?.id;
                    });

                    if (!isExist) {
                      const parsedApprovedBy = {
                        id: approvedBy?.id,
                        user_id: approvedBy?.id,
                        user: {
                          name: approvedBy?.name,
                          email: approvedBy?.email,
                        },
                      };
                      setMemberListState((current) => {
                        return current.concat(parsedApprovedBy);
                      });
                    }

                    form.setFieldsValue({
                      type: integrator?.type,
                      user_socmed_id: integrator?.user_socmed_id,
                      created_by_id: integrator?.created_by_id,
                      approved_by_id: integrator?.approved_by_id,
                    });
                    setIntegratorValue(value);
                  }}
                  onClear={() => {
                    form.setFieldsValue({
                      type: null,
                      user_socmed_id: null,
                      created_by_id: null,
                      approved_by_id: null,
                    });
                    setIntegratorValue(null);
                    setIntegratorKeyword('');
                  }}
                  // labelInValue
                >
                  {adIntegratorList.map((item) => {
                    return (
                      <Select.Option
                        value={item?.id}
                        label={item}
                        key={item?.id}
                      >
                        {`${item?.ad?.name || ''} (${
                          item?.id && getLastSubId(item?.id)
                        })`}
                      </Select.Option>
                    );
                  })}
                </Select>
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={24}>
            <Col span={12}>
              <Form.Item label="Social Network" name="type">
                <Select
                  placeholder="All Social Network"
                  allowClear
                  filterOption={false}
                  onSelect={(value) => {
                    setSocmedType(value);
                  }}
                  defaultValue="all"
                  disabled={
                    integratorValue !== null ||
                    Boolean(form.getFieldValue('integrator_id'))
                  }
                  onClear={() => {
                    setSocmedType(null);
                  }}
                  loading={isLoadingSocmed}
                >
                  <Select.Option value="all" disabled>
                    All Social Network
                  </Select.Option>
                  {socmedTypeList.map((item) => {
                    return (
                      <Select.Option
                        value={item?.value}
                        label={item?.name}
                        key={item?.id}
                      >
                        {item?.label}
                      </Select.Option>
                    );
                  })}
                </Select>
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item label="Social Account" name="user_socmed_id">
                <Select
                  placeholder="Search social account name"
                  showSearch
                  allowClear
                  onSearch={(e) => {
                    onSearch(e, setSocmedKeyword);
                  }}
                  notFoundContent={
                    isLoadingSocmed ? <Spin size="small" /> : 'Not found'
                  }
                  filterOption={false}
                  loading={isLoadingSocmed}
                  disabled={
                    integratorValue !== null ||
                    Boolean(form.getFieldValue('integrator_id'))
                  }
                >
                  {socmedList.map((item) => {
                    return (
                      <Select.Option
                        value={item?.id}
                        label={item?.name}
                        key={item?.id}
                      >
                        {`${item?.username} (${item?.url})`}
                      </Select.Option>
                    );
                  })}
                </Select>
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={24}>
            <Col span={12}>
              <Form.Item label="Start Date" name="start_date">
                <DatePicker placeholder="DD/MM/YYYY" />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item label="End Date" name="end_date">
                <DatePicker
                  placeholder="DD/MM/YYYY"
                  format="YYYY/MM/DD"
                  disabledDate={(current) => {
                    return (
                      current && current <= form.getFieldValue('start_date')
                    );
                  }}
                />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={24}>
            <Col span={12}>
              <Form.Item label="Created By" name="created_by_id">
                <Select
                  placeholder="Search by Name"
                  showSearch
                  allowClear
                  onSearch={(e) => {
                    onSearch(e, setMemberKeyword);
                  }}
                  notFoundContent={
                    isLoadingMember ? <Spin size="small" /> : 'Not found'
                  }
                  filterOption={false}
                  loading={isLoadingMember}
                  onFocus={() => {
                    setMemberKeyword('');
                  }}
                  disabled={
                    integratorValue !== null ||
                    Boolean(form.getFieldValue('integrator_id'))
                  }
                  optionLabelProp="label"
                >
                  {memberListState.map((item) => {
                    return (
                      <Select.Option
                        value={item?.user_id}
                        label={item?.user?.name}
                        key={item?.id}
                      >
                        <AccountCard
                          fontRegular
                          name={item?.user?.name}
                          description={item?.user?.email}
                        />
                      </Select.Option>
                    );
                  })}
                </Select>
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item label="Approved By" name="approved_by_id">
                <Select
                  placeholder="Search by Name"
                  showSearch
                  allowClear
                  onSearch={(e) => {
                    onSearch(e, setMemberKeyword);
                  }}
                  notFoundContent={
                    isLoadingMember ? <Spin size="small" /> : 'Not found'
                  }
                  filterOption={false}
                  loading={isLoadingMember}
                  onFocus={() => {
                    setMemberKeyword('');
                  }}
                  disabled={
                    integratorValue !== null ||
                    Boolean(form.getFieldValue('integrator_id'))
                  }
                  optionLabelProp="label"
                >
                  {memberListState.map((item) => {
                    return (
                      <Select.Option
                        value={item?.user_id}
                        label={item?.user?.name}
                        key={item?.id}
                      >
                        <AccountCard
                          fontRegular
                          name={item?.user?.name}
                          description={item?.user?.email}
                        />
                      </Select.Option>
                    );
                  })}
                </Select>
              </Form.Item>
            </Col>
          </Row>
        </div>
        <div className="containers_advanceFilter_footer">
          {!refinerNewReport && (
            <Button
              type="secondary"
              onClick={() => {
                onHideAdvFilter();
              }}
            >
              Cancel
            </Button>
          )}
          <div className="containers_advanceFilter_footer-search">
            <Button
              type="primary"
              onClick={() => {
                onReset(form);
              }}
            >
              Reset
            </Button>
            <Button type="primary" htmlType="submit">
              Search
            </Button>
          </div>
        </div>
      </Form>
    </AdvanceFilterWrapper>
  );
};

export default Index;
